module.exports = require('./lib/ReactWithAddons');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react/addons.js
 ** module id = 4
 ** module chunks = 0
 **/